exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".asset-list-page--container {\n  width: 100%;\n  padding: 0 40px 40px 40px;\n}\n\n.asset-list-page-row-actions--container > a {\n  text-decoration: none;\n  display: inline-block;\n  margin-right: 12px;\n}\n\n.asset-list-page--description {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 16px;\n}", ""]);

